import { render, staticRenderFns } from "./card-buttons.vue?vue&type=template&id=48c14247&"
import script from "./card-buttons.vue?vue&type=script&lang=js&"
export * from "./card-buttons.vue?vue&type=script&lang=js&"
import style0 from "./card-buttons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports